import React, { useState, useEffect } from 'react'
import { Form, Container, Col, Row, FormGroup, FormFeedback, Input } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'

import './styles.scss'

import { get } from 'redux/centers/actions'
import * as OperatorAct from '../../../redux/actions/operators'

import { isAvailableRole } from 'services/PlanRestrictions'
import OperatorValidator from './validator'
import { SelectWithLabel, Button as ButtonNormal } from 'components/Form'
import { toastMessage } from 'utils/messages'
import ModalPlan from 'components/ModalPlan'
import SelectBrandsAndDelegations from '../../Form/SelectBrandDelegations'
import OperatorAutomaticAssigment from './OperatorAutomaticAssigment'
import InputControls from 'components/common/InputControls'
import ReactTooltip from 'react-tooltip'

const OperatorEdit = (props) => {
  const { operator: operatorEdit, roles, company, onHideModal, type, dispatch } = props

  const OperatorActions = bindActionCreators(OperatorAct, dispatch)
  const currentPlan = useSelector(store => store.currentPlan)

  const [operator, setOperator] = useState({
    name: '',
    lastname: '',
    email: '',
    role: '',
    company: company._id,
    brands: [],
    delegations: [],
    brandNames: [],
    delegationNames: [],
    available: false,
    isAutomaticAssigned: false,
    maxConversationAssigned: 0,
    channelPriority: [],
    onlyAssignedConversations: false,
    allowMetricsAccess: false
  })

  const [lockButtons, setLockButtons] = useState(false)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showPlanModal, setShowPlanModal] = useState(false)


  const onTogglePlanModal = ()=> setShowPlanModal(!showPlanModal)

  useEffect(() => {
    if (operatorEdit) {
      setOperator(operatorEdit)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operatorEdit])

  useEffect(() => {
    dispatch(get({ refresh: true }))
  }, [dispatch, type])

  const handleSubmit = async (e) => {
    try {
      setLockButtons(true)
      const errors = OperatorValidator(operator)

      if (!Object.keys(errors).length) {
        setIsSubmitting(true)
        if (type === 'add') {
          await OperatorActions.addNewOperator(operator)
          toastMessage(I18n.t('dashuser_message_add_operator'))
        } else if (type === 'edit') {
          await OperatorActions.updateOperator(operator)
          toastMessage(I18n.t('dashuser_message_successful'))
        }
        setIsSubmitting(false)
        setErrors({})
        onHideModal()
      } else {
        setErrors(errors)
      }
    } catch (e) {
      setIsSubmitting(false)
      toastMessage(e.type || I18n.t('generic_error'), 'error')
      setErrors({ [e.field || 'global']: e.type || 'generic_error' })
    } finally {
      setIsSubmitting(false)
      setLockButtons(false)
    }
  }



  const onSelectBrandsDelegations = (type, value) => {
    let newBrands = operator.brands
    let brandNames = operator.brandNames
    let delegationNames = operator.delegationNames

    switch (type) {
      case 'brands': {
        brandNames = value.map((b) => b.data)
        const currentSelected = value.map((b) => b.value)
        delegationNames = delegationNames.filter((d) => currentSelected.includes(d.brand))
        newBrands = currentSelected.reduce((current, next) => {
          const isSelected = newBrands.find((b) => b.id === next)
          current.push(isSelected || { id: next })
          return current
        }, [])
        break
      }
      case 'delegations': {
        const currentSelected = value.map((d) => d.data)
        delegationNames = [...currentSelected]
        newBrands.forEach((brand) => {
          const delegations = currentSelected.filter((delegation) => delegation.brand === brand.id).map((d) => d._id)
          brand.delegations = delegations.length ? delegations : []
        })
        break
      }
      default:
        break
    }
    setOperator({ ...operator, brands: newBrands, brandNames, delegationNames })
  }

  const handleOperator = async (remove) => {
    try {
      setLockButtons(true)

      if (remove) {
        await OperatorActions.deleteOperator(operator)
        toastMessage(I18n.t('dashuser_message_remove_operator'))
      } else {
        operator.isActive = false
        await OperatorActions.updateOperator(operator)
        toastMessage(I18n.t('dashuser_message_desactivate_operator'))
      }
      onHideModal()
    } catch (e) {
      toastMessage(I18n.t('generic_error'))
      console.error(e.message)
    } finally {
      setLockButtons(false)
    }
  }

  const handleChange = ({ target }) => setOperator({ ...operator, [target.name]: target.value })


  const getRoleFormat = (roles) => {
    return roles.map((role) => {
      const disabled = !isAvailableRole(currentPlan, role)

      return ({
        value: role,
        label: (
          <>
            <span style={{ paddingRight: '5px' }}>{I18n.t(`roles_${role}`)}</span>
            {
              disabled
                ? (
                  <>
                    <i data-tip={I18n.t('dashuser_tooltip_only-premium-plan')} className='fa fa-info-circle pl-2' id={`roles_${role}`} style={{ fontSize: '1rem' }} onClick={onTogglePlanModal} />
                    <ReactTooltip place='bottom' className='react-tooltip-custom-style' />
                  </>
                )
                : null
            }
          </>
        ),
        disabled: disabled,
      })
    })
  }

  return (
    <Form onSubmit={handleSubmit} className='edit-operator-form' autoComplete='off'>
      <Container>
        <Row>
          <Col xs={12}>
            <FormGroup row>
              <h1>
                {type === 'add'
                  ? I18n.t(company.type === 'OP' ? 'dashboard_new-manager' : 'dashboard_new-operator')
                  : I18n.t(company.type === 'OP' ? 'dashboard_edit-manager' : 'dashboard_edit-operator')
                }
              </h1>
            </FormGroup>
          </Col>
        </Row>
        <div className='seccion-one'>
          <label htmlFor='dashuser.email' className='label'>{I18n.t('dashboard_email')}</label>
          <div className='seccion-two'>
            {
              operator.isComplete
                ? (
                  <div className='input input_edit_disabled'>
                    {operator.email || ''}
                  </div>
                ) : (
                  <Input
                    name='email'
                    type='email'
                    id='dashuser.email'
                    autoComplete='off'
                    role="presentation"
                    className='input'
                    disabled={lockButtons}
                    value={operator.email}
                    onChange={handleChange}
                    invalid={!!errors.email}
                    onBlur={() => {
                      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                      if (!regex.test(operator.email)) {
                        setErrors({ ...errors, 'email': 'dashboard_enter-valid-email' })
                      } else {
                        let e = errors
                        delete e.email
                        setErrors({ ...e })
                      }
                    }}
                  />
                )
            }
            <FormFeedback>{errors.email ? I18n.t(errors.email) : ''}</FormFeedback>
          </div>
        </div>
        <div className='seccion-one'>
          <label htmlFor='dashuser.role' className='label'>{I18n.t('dashboard_rol')}</label>
          <div className='seccion-two'>
            <SelectWithLabel
              name='dashuser.role'
              key='dashuser.role'
              id='dashuser.role'
              placeholder={I18n.t('dashboard_choose-role')}
              classNameWrapper='select-roles'
              options={getRoleFormat(roles)}
              value={operator.role && { value: operator.role, label: I18n.t(`roles_${operator.role}`) }}
              onChange={({ value }) => handleChange({ target: { name: 'role', value } })}
              isDisabled={lockButtons}
              isOptionDisabled={(option) => option.disabled}
            />
            <Input hidden invalid={!!errors.role} />
            <FormFeedback>{errors.role ? I18n.t(errors.role) : ''}</FormFeedback>
          </div>
        </div>
        <div className='seccion-one-brands'>
          <SelectBrandsAndDelegations
            isMultiline
            currentBrands={operator.brandNames}
            currentDelegations={operator.delegationNames}
            onChange={onSelectBrandsDelegations}
            operatorRole={operator.role}
            isDisabled={lockButtons}
            brandClassName='wrapper-brands'
            delegationClassName='wrapper-delegations'
          />
          <div className='seccion-two'>
            <Input hidden invalid={!!errors.brands || !!errors.delegations} />
            <FormFeedback>{(errors.brands || errors.delegations) ? I18n.t('dashuser_message_brand_required') : ''}</FormFeedback>
          </div>
        </div>
        {
          operator.role === 'operator'
            ? (
              <>
                <div className='seccion-one operator-asignment-center'>
                  <label htmlFor='operator_only_metrics_access' className='label'>
                    {I18n.t('operator_only_metrics_access')}
                  </label>
                  <div className='seccion-two'>
                    <InputControls
                      name='operator_only_metrics_access'
                      color='primary'
                      value={operator.allowMetricsAccess || false}
                      onChange={(value) => handleChange({ target: { name: 'allowMetricsAccess', value } }) }
                    />
                  </div>
                </div>
                <div className='seccion-one operator-asignment-center'>
                  <label htmlFor='operator_only_assigned_conversations' className='label'>
                    {I18n.t('operator_only_assigned_conversations')}
                  </label>
                  <div className='seccion-two'>
                    <InputControls
                      name='operator_only_assigned_conversations'
                      color='secondary'
                      value={operator.onlyAssignedConversations || false}
                      onChange={(value) => handleChange({ target: { name: 'onlyAssignedConversations', value } }) }
                    />
                  </div>
                </div>
              </>
            ) : null
        }
        {
          operator._id
            ? (
              <OperatorAutomaticAssigment
                setOperator={(data) => setOperator({ ...operator, ...data })}
                isAutomaticAssigned={operator.isAutomaticAssigned}
                maxConversationAssigned={operator.maxConversationAssigned}
                operatorId={operator._id}
                disabled={lockButtons}
              />
            )
            : null
        }
        <div className='mt-4'>
          <Row>
            <Col sm="4">
              <ButtonNormal
                secondary
                value={I18n.t('dashboard_save')}
                isSubmitting={isSubmitting}
                disabled={lockButtons}
                onClick={(e)=>handleSubmit(e)}
              />
            </Col>

            <Col sm="4">
              {type === 'add' ? (
                <ButtonNormal
                  disabled={lockButtons}
                  value={I18n.t('dashboard_cancel')}
                  onClick={onHideModal}
                />
              ) : !operator.isComplete && !operator.isActive ? (
                <ButtonNormal
                  remove
                  disabled={lockButtons}
                  value={I18n.t('dashboard_delete')}
                  onClick={() => handleOperator(true)}
                />
              ) : (
                <ButtonNormal
                  remove
                  disabled={lockButtons}
                  value={I18n.t('dashboard_deactivate')}
                  onClick={() => handleOperator(false)}
                />
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <ModalPlan
        isOpen={showPlanModal}
        toggle={onTogglePlanModal}
      />
    </Form>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user,
    roles: state.roles,
    company: state.companies,
    operators: state.operators
  }
}

export default connect(mapStateToProps)(OperatorEdit)
